module.exports = __webpack_public_path__ + "static/media/onlinephysiotherapy_scott.95207125.png";